<template>
    <div class="resume-item-module">
        <h1 class="module-title">教育经历
            <el-button type="text" class="pull-right f-edit" @click="addItem">添加</el-button>
        </h1>
        <template v-for="(item, index) in data">
            <education :init="item" :key="item.id || item._index" :ref="'education' + index"
                       @remove="removeItem"></education>
        </template>
    </div>
</template>
<script type="text/javascript">
    import Education from './items/education'
    import { education } from './itemsData'

    export default {
        props: {
            data: [Object, Array]
        },
        data () {
            return {
                isPass: true
            }
        },
        methods: {
            addItem () {
                if (this.data.length === 5) {
                    this.$message.error(`教育经历不能超过${this.data.length}`)
                    return false
                }
                let item = Object.assign({}, education, {
                    resumeId: this.$route.params.id,
                    isEdit: true,
                    _index: Date.now()
                })
                this.data.push(item)
            },
            removeItem (id) {
                if (this.data.length === 1) {
                    this.$message.error(`教育经历至少要有一个`)
                    return false
                }
                let targetIndex = ''
                this.data.forEach((item, index) => {
                    if (id === item.id || id === item['_index']) {
                        targetIndex = index
                    }
                })
                this.data.splice(targetIndex, 1)
            },
            saveAllEducation (callback) {
                let arr = []
                this.data.forEach((item, index) => {
                    this.$refs['education' + index][0].saveData('ruleForm', (data) => {
                        arr.push(data)
                    })
                })
                this.isPass = arr.length === this.data.length
                callback(arr)
            },
            resetAllEducation () {
                this.data.forEach((item, index) => {
                    this.$refs['education' + index][0].resetForm('ruleForm')
                })
            }
        },
        components: {
            Education
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";
</style>


// WEBPACK FOOTER //
// educationModule.vue?6bf2455d